import { get } from 'lodash'

const isFieldEmpty = (fieldValue) => {
  return !fieldValue || fieldValue === ''
}

const isValidFromControl = (formControlData, validations) => {
  let isValid = true
  if (validations.required) {
    isValid = !isFieldEmpty(formControlData)

    // check the reg expression
    if (validations.regEx) {
      isValid = validations.regEx.test(formControlData)
    }

    // Add other Validations here
  } else if (!isFieldEmpty(formControlData)) {
    // check the reg expression only of the value is present

    if (validations.regEx) {
      isValid = validations.regEx.test(formControlData)
    }

    // Add other Validations here
  } else {
    // do nothing
  }

  return isValid
}

export const validateRequiredFormData = (formData, mandatoryFields) => {
  let errorKeys = {}
  let isFormValid = true

  Object.keys(formData).forEach((key) => {
    const formControlData = formData[key]
    if (Array.isArray(formControlData)) {
      // for Arrays
      let arrayErrorList = []
      formControlData.forEach((listItem) => {
        const { errorKeys: errorKeyObject, isFormValid: listIemIsFormValid } =
          validateRequiredFormData(listItem, mandatoryFields)
        arrayErrorList.push(errorKeyObject)
        if (isFormValid) {
          isFormValid = listIemIsFormValid
        }
      })
      errorKeys[key] = arrayErrorList
    } else if (formControlData && typeof formControlData === 'object') {
      // for Objects
      const { errorKeys: errorKeyObject, isFormValid: listIemIsFormValid } =
        validateRequiredFormData(formControlData, mandatoryFields)
      errorKeys[key] = errorKeyObject
      if (isFormValid) {
        isFormValid = listIemIsFormValid
      }
    } else {
      // for other types
      const validations = mandatoryFields[key]
      if (validations && !isValidFromControl(formControlData, validations)) {
        errorKeys[key] = {
          error: true,
        }
        isFormValid = false
      }
    }
  })

  return { errorKeys, isFormValid }
}

const isFormControlError = (form, key) => {
  return get(form.touched, key) && Boolean(get(form.errors, key))
}

const getFormControlErrorText = (form, key) => {
  return get(form.touched, key) && get(form.errors, key)
}

export { isFormControlError, getFormControlErrorText }
